import { isWatchPage } from "./shared.js";
let pauseObserver = null;
let lastPausedVideo = null;
const observeVideos = () => {
    pauseObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node instanceof HTMLElement) {
                    if (node.tagName === "VIDEO") {
                        pauseVideo(node);
                    }
                }
            });
        });
    });
    pauseObserver.observe(document.documentElement || document.body, {
        childList: true,
        subtree: true,
    });
};
const playListener = (event) => {
    if (event.target instanceof HTMLVideoElement && isWatchPage()) {
        lastPausedVideo = event.target;
        lastPausedVideo.pause();
    }
};
const pauseVideo = (video) => {
    if (!video.paused && isWatchPage()) {
        lastPausedVideo = video;
        video.pause();
    }
    video.addEventListener("play", playListener);
};
export const startPause = () => {
    const videos = document.querySelectorAll("video");
    videos.forEach(pauseVideo);
    observeVideos();
};
export const stopPause = () => {
    pauseObserver === null || pauseObserver === void 0 ? void 0 : pauseObserver.disconnect();
    pauseObserver = null;
    resumeCurrentVideo();
};
export const pauseCurrentVideos = () => {
    const videos = document.querySelectorAll("video");
    videos.forEach((video) => {
        video.removeEventListener("play", playListener);
        pauseVideo(video);
    });
};
export const resumeCurrentVideo = () => {
    const videos = document.querySelectorAll("video");
    videos.forEach((video) => {
        video.removeEventListener("play", playListener);
    });
    void (lastPausedVideo === null || lastPausedVideo === void 0 ? void 0 : lastPausedVideo.play());
};
